<!-- eslint-disable tailwindcss/no-custom-classname -->
<!-- eslint-disable vue/no-v-html -->
<template>
  <ContentSection :spacing="spacing">
    <Container class="grid lg:grid-cols-2">
      <!-- Image -->
      <AppImage :src="data.image" class="aspect-video size-full object-cover" :class="{ 'lg:order-2': data.image_position?.value === 'right' }" />
      <!-- Text -->
      <div
        class="pb-9 pt-8 lg:px-9"
        :class="[
          {
            'bg-gradient-01 text-white': data.background_color?.value === 'gradient-01',
            'bg-grey-100': data.background_color?.value === 'grey',
            'bg-white': data.background_color?.value === 'white',
          },
        ]"
      >
        <AnimatedContainer
          class="flex h-full flex-col max-lg:px-container"
          :class="[
            {
              'justify-start': data.content_position?.value === 'top' || (!data.link && data.content_position?.value === 'default'),
              'justify-center': data.content_position?.value === 'middle',
              'justify-end': data.content_position?.value === 'bottom',
              'justify-between': data.content_position?.value === 'default' && data.link,
            },
          ]"
        >
          <div
            v-if="data.text"
            class="max-w-text wysiwyg slide-up"
            :class="[{
              'wysiwyg-negative': data.background_color?.value === 'gradient-01',
            }] "
            v-html="data.text"
          />
          <div
            v-if="data.link"
            class="slide-up pt-4"
            :class="[
              {
                'mt-auto': data.content_position?.value === 'default' && data.link,
              },
            ]"
          >
            <AppButton
              :inverted="data.background_color?.value === 'gradient-01'"
              class="max-sm:w-full"
              :to="data.link"
            >
              {{ data.link_text }}
            </AppButton>
          </div>
        </AnimatedContainer>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsImageWithTextFragment } from '#gql'

const props = defineProps<{
  data: Enforce<MainComponentsImageWithTextFragment>
  prevComponent?: string
  nextComponent?: string
}>()

const spacing = computed(() => {
  if (props.data.collapse_spacing?.value === 'collapse') {
    if (props.nextComponent === 'image_with_text') {
      return 'lg-bottom-collapse'
    }

    if (props.prevComponent === 'image_with_text') {
      return 'lg-top-collapse'
    }
  }

  return undefined
})
</script>
